import styled from "styled-components";

export const LayerListIconContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  pointer-events: none;

  svg:not(.widget-icon) {
    width: 50px !important;
    height: 50px !important;
    stroke-width: 5px !important;
  }
`;
